export default __webpack_public_path__ + "static/8-3752b91a1bf193c440ad5241ff2a6d95.png";